<div class="total-records">
  <span>
    {{name ? name : 'Total Records'}}&nbsp;:&nbsp;{{count}}
  </span>
</div>